import { PushNotificationService } from 'data/services';
import { PushNotificationServiceInterface } from 'domain/services';
import { makePushNotification } from 'main/factories/usecases/push-notification/remote-push-notification-factory';

export const makePushNotificationService =
  (): PushNotificationServiceInterface => {
    return new PushNotificationService({
      pushNotification: makePushNotification(),
    });
  };
